import React from 'react';
import T from 'prop-types';
import Icon from '@ably/ui/core/Icon';

import { DetailsInfoSection } from '../details-info-section';

const BillingAddressProps = T.shape({
  lineOne: T.string,
  lineTwo: T.string,
  city: T.string,
  countryCode: T.string,
  region: T.string,
  postCode: T.string,
});

const Header = ({ title, subTitle }) => (
  <>
    <h1 className="ui-text-h1 mt-10 mb-3.5">{title}</h1>
    <p className="ui-text-p3 mb-8">{subTitle}</p>
    <hr className="my-0 mb-8" />
  </>
);

Header.propTypes = {
  title: T.string,
  subTitle: T.oneOfType([T.string, T.element]),
};

const PackageDetails = ({ additionalCSS, packageDetails }) => {
  const resourceSectionDetails = {
    heading: `Ably ${packageDetails.packageName} subscription details`,
    list: packageDetails.packageId
      ? [
          { [`${packageDetails.packageName} monthly fee `]: packageDetails.basePrice },
          {
            [`Price per million messages${packageDetails.pricePerMillionMessages?.upper ? ` (first ${packageDetails.pricePerMillionMessages.upper})` : ''}`]:
              packageDetails.pricePerMillionMessages?.price,
          },
          {
            [`Price per million channel minutes${packageDetails.pricePerChannelMinute?.upper ? ` (first ${packageDetails.pricePerChannelMinute.upper})` : ''}`]:
              packageDetails.pricePerChannelMinute?.price,
          },
          {
            [`Price per million connection minutes${packageDetails.pricePerConnectionMinute?.upper ? ` (first ${packageDetails.pricePerConnectionMinute.upper})` : ''}`]:
              packageDetails.pricePerConnectionMinute?.price,
          },
          {
            '': (
              <>
                See our{' '}
                <a href="/pricing" target="_blank">
                  pricing page
                </a>{' '}
                for volume discounts
              </>
            ),
          },
        ]
      : [
          { Messages: packageDetails.messages },
          { 'Peak concurrent channels': packageDetails.peakConcurrentChannels },
          { 'Peak concurrent connections': packageDetails.peakConcurrentConnections },
        ],
  };
  const supportSectionDetails = {
    description: 'Support',
    list: [
      { 'Support hours': packageDetails.supportHours },
      { 'Response time': packageDetails.responseTime },
      { Channels: packageDetails.channels },
    ],
  };
  return (
    <div className={additionalCSS}>
      <DetailsInfoSection {...resourceSectionDetails} />
      <DetailsInfoSection {...supportSectionDetails} />

      <div className="bg-blue px-5 py-4 text-p3 flex items-center" style={{ backgroundColor: '#E7F6FD' }}>
        <Icon name="icon-gui-information-circle-outline" size="1.5rem" additionalCSS="flex-shrink-0 mr-3" />
        <p>
          Prices above exclude sales tax. Total including tax will be stated on invoices and charged to your payment
          method.
        </p>
      </div>
    </div>
  );
};

PackageDetails.propTypes = {
  additionalCSS: T.string,
  packageDetails: T.shape({
    packageId: T.string,
    packageName: T.string,
    basePrice: T.string,
    pricePerMillionMessages: T.shape({
      upper: T.string,
      price: T.string,
    }),
    pricePerChannelMinute: T.shape({
      upper: T.string,
      price: T.string,
    }),
    pricePerConnectionMinute: T.shape({
      upper: T.string,
      price: T.string,
    }),
    messages: T.string,
    peakConcurrentChannels: T.string,
    peakConcurrentConnections: T.string,
    supportHours: T.string,
    responseTime: T.string,
    channels: T.string,
  }),
};

export { BillingAddressProps, Header, PackageDetails };
